import React, { useEffect, useRef, useState } from "react";
import diretorErikTrovilho from "../../assets/mp4/diretorErikTrovilho.mp4";
import diretorRaphaBorges from "../../assets/mp4/diretorRaphaBorges.mp4";
import "./index.css";
import Header from "../Header";
import { Link } from "react-router-dom";
import ScrollAnimado from "../ScrollAnimado";
export default function Diretores() {
  return (
    <>
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={diretorErikTrovilho} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>
        <Header />



        <Link to={"/diretores/erik-trovilho"}>
          <div className="tituloDiretor">
            Erik <br />
            Trovilho
          </div>
        </Link>


        
      </div>
      <ScrollAnimado />
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={diretorRaphaBorges} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>
        <Link to={"/diretores/rapha-borges"}>
          <div className="tituloDiretor">
            Rapha <br />
            Borges
          </div>
        </Link>
      </div>
    </>
  );
}
